<template>
    <div :class="['codelab-media-uploader',type]">
        <template v-if="type === 'card'">
            <div class="media-thumb">
                <svg-icon v-if="media.mediaType === 'video'" :href="uploadThumb" :width="80" :height="80"></svg-icon>
                <img v-if="media.mediaType === 'photo'" :src="uploadThumb">
                <el-progress
                    class="upload-progress"
                    type="circle"
                    :width="48"
                    :stroke-width="4"
                    :percentage="media.percent"
                    :format="format"
                    color="url(#line-grad1)"
                >
                </el-progress>
            </div>
            <div class="media-name">{{media.metadata.title}}</div>
        </template>
        <template v-else>
            <span class="delete"></span>
            <span class="name">{{media.metadata.title}}</span>
            <span class="progress">
                <el-progress
                    class="upload-progress"
                    :stroke-width="8"
                    :percentage="media.percent"
                    :format="format"
                    color="url(#line-grad1)"
                >
                </el-progress>
            </span>
        </template>
    </div>
</template>
<script>
export default {
    name: "media-uploader",
    props: {
        media: Object,
        type: String
    },
    computed: {
        uploadThumb(){
            if(this.media.mediaType !== "photo"){
                return "#codelab-media-type-" + this.media.mediaType;
            } else {
                return this.media.screenshot;
            }
        }
    },
    methods: {
        format(percent){
            return percent === 100 ? this.$t("upload_formating") : `${percent}%`;
        }
    }
}
</script>
<style lang="scss">
    .codelab-media-uploader{
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
        &.card{
            .upload-progress {
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                background: rgba(0, 0, 0, 0.6);
                z-index: 3;
                &.is-success {
                    background: none;
                    transform-origin: center;
                    animation: scale-out ease-out 0.4s;
                    animation-fill-mode: forwards;
                }
                &.is-exception {
                    .el-progress-circle__path {
                        stroke: #ff4949 !important;
                    }
                }
                .el-progress-circle {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin-left: -24px;
                    margin-top: -24px;
                }
                .el-progress__text {
                    color: #ffffff;
                    font-size: 16px;
                    .el-icon-check {
                        color: #45e5f4;
                        font-size: 22px;
                    }
                    .el-icon-close {
                        color: #ff4949;
                        font-size: 22px;
                    }
                }
            }
        }
        &.list{
            &>span{
                text-align: left;
                display: inline-block;
                font-size: 14px;
                color: #ffffff;
                padding: 0 6px;
                position: relative;
                vertical-align: middle;
            }
            .delete{
                width: 55px;
            }
            .name{
                width: 320px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .progress{
                width: calc(100% - 55px - 320px);
                .upload-progress {
                    width: 100%;
                    height: 45px;
                    line-height: 39px;
                    &.is-success {
                        background: none;
                        animation: opacity-out ease-out 0.4s;
                        animation-fill-mode: forwards;
                        .el-progress-bar__outer {
                            .el-progress-bar__inner {
                                &::before {
                                    animation: none;
                                    display: none;
                                }
                            }
                        }
                    }
                    &.is-exception {
                        .el-progress-bar__outer {
                            .el-progress-bar__inner {
                            background: #ff4949;
                                overflow: hidden;
                                &::before {
                                    display: none;
                                    animation: none;
                                }
                            }
                        }
                    }
                    .el-progress-bar__outer {
                        background: #444444;
                        .el-progress-bar__inner {
                            background: linear-gradient(to right, #00b5e2, #13de7d);
                            overflow: hidden;
                            &::before {
                                content: "";
                                display: block;
                                width: 24px;
                                height: 100%;
                                position: absolute;
                                left: 0%;
                                opacity: 1;
                                animation: fly-to-end ease-in-out 5s infinite;
                                animation-delay: 3s;
                                background: radial-gradient(
                                    rgba(255, 255, 255, 0.8) 0%,
                                    rgba(255, 255, 255, 0) 80%,
                                    rgba(255, 255, 255, 0) 100%
                                );
                            }
                        }
                    }
                    .el-progress__text {
                        color: #ffffff;
                        font-size: 12px !important;
                        .el-icon-circle-check {
                            color: #45e5f4;
                        }
                        .el-icon-close {
                            color: #ff4949;
                        }
                    }
                }
            }
        }
        
    }
@keyframes scale-out {
    from {
        transform: scale(1);
        opacity: 1;
    }
    to {
        transform: scale(0);
        opacity: 0.2;
    }
}
@keyframes opacity-out {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}
@keyframes fly-to-end {
    0% {
        left: -24px;
    }
    30% {
        left: 100%;
    }
    100% {
        left: 100%;
    }
}
</style>